import { render } from "./OtherConfig.vue?vue&type=template&id=9680e39c"
import script from "./OtherConfig.vue?vue&type=script&lang=js"
export * from "./OtherConfig.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__